import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import logo2 from '../assets/logo2.png';
import './Footer.css';

const VENUE_TZ = 'America/Chicago';

function parseYmdToUtcNoon(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr.trim());
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  if (!Number.isFinite(y) || !Number.isFinite(mo) || !Number.isFinite(d)) return null;
  return new Date(Date.UTC(y, mo - 1, d, 12, 0, 0));
}

function formatDateLong(dateStr) {
  if (!dateStr) return '';
  const t = parseYmdToUtcNoon(dateStr);
  if (Number.isNaN(t.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    timeZone: VENUE_TZ,
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  }).format(t);
}

const Footer = ({ events = [] }) => {
  if (!events.length) return null;

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-content">
          {/* Venue Info */}
          <div className="footer-section-block">
            <h3 className="footer-title">The Retro Street</h3>
            <div className="footer-address">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="footer-icon" />
              <div>
                <p>307 Main St</p>
                <p>Frisco, TX 75034</p>
              </div>
            </div>
            <a
              href="https://www.google.com/maps/search/?api=1&query=307+Main+St+Frisco+TX"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link map-link"
            >
              View on Google Maps
            </a>
          </div>

          {/* Contact Info */}
          <div className="footer-section-block">
            <h3 className="footer-title">Follow Us</h3>
            <div className="footer-contact">
              <a
                href="https://www.instagram.com/theretrostreett/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                <FontAwesomeIcon icon={faInstagram} className="footer-icon" />
                <span>@theretrostreett</span>
              </a>
            </div>
          </div>

          {/* Event Info */}
          <div className="footer-section-block">
            <h3 className="footer-title">Event Info</h3>
            {events.map((event) => (
              <div key={event.id} className="footer-event-item">
                <p className="footer-text footer-event-title">{event.title}</p>
                <p className="footer-text">{formatDateLong(event.date) || event.formattedDate || ''}</p>
              </div>
            ))}
            {/* <p className="footer-text">21+ Event</p> */}
          </div>
        </div>

        {/* Powered By */}
        <div className="footer-bottom">
          <div className="footer-logo-wrapper">
            <img src={logo2} alt="Logo" className="footer-logo" />
          </div>
          <p className="footer-powered">
            Powered by{' '}
            <a 
              href="https://brisque.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-brand"
            >
              Brisque
            </a>
          </p>
          <p className="footer-copyright">
            © {new Date().getFullYear()} The Retro Street. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
